import type { LoaderSize } from './types'

/**
 * Диаметр спиннера по size. Кольцо крупнее прежнего (16/24/32): на тёмном фоне тонкий мелкий
 * спиннер читался как соринка, а не как «идёт загрузка».
 */
export const LOADER_SIZE: Record<LoaderSize, number> = {
  S: 22,
  M: 34,
  L: 46,
}
